import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import EvaluationsRoutes from "./evaluations/index";
import PageNotFound from "../views/error/PageNotFound";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    ...EvaluationsRoutes,
    { path: "*", name: "ErrorPage", component: PageNotFound },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
